<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-merge-cells`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 30v10h4v-1a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1H6a2 2 0 01-2-2V30h4zm36 0v12a2 2 0 01-1.85 1.995L42 44h-9a1 1 0 01-.993-.883L32 43v-4a1 1 0 01.883-.993L33 38h2a1 1 0 01.993.883L36 39v1h4V30h4zm0-8v4h-9v-4h9zm-31 0v4H4v-4h9zM42 4a2 2 0 011.995 1.85L44 6v12h-4V8h-4v1a1 1 0 01-.883.993L35 10h-2a1 1 0 01-.993-.883L32 9V5a1 1 0 01.883-.993L33 4h9zM15 4a1 1 0 011 1v4a1 1 0 01-1 1h-2a1 1 0 01-1-1V8H8v10H4V6a2 2 0 012-2h9zm4.933 20.8l-5.333 4A1 1 0 0113 28v-8a1 1 0 011.6-.8l5.333 4a1 1 0 010 1.6zm8.134 0l5.333 4A1 1 0 0035 28v-8a1 1 0 00-1.6-.8l-5.333 4a1 1 0 000 1.6z"/></svg>
</template>
<script>

export default {
  name: 'IconMergeCells',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
